import { render } from "./AddresPages.vue?vue&type=template&id=4f0edfb3&scoped=true"
import script from "./AddresPages.vue?vue&type=script&lang=js"
export * from "./AddresPages.vue?vue&type=script&lang=js"

import "./AddresPages.vue?vue&type=style&index=0&id=4f0edfb3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f0edfb3"]])

export default __exports__